import {useState, useEffect, useRef} from "react";
import DynaInput from "../../DynaInput/DynaInput";
import "./UserInformation.scss";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import {DateObject} from "react-multi-date-picker";
import axios from "axios";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import {prefixUrl} from "../../../../Utils/utilsData";

const UserInformation = () => {
  // State variables for input values
  const [fullName, setfullName] = useState("");
  const [nationalCode, setNationalCode] = useState("");
  const [mobile, setmobile] = useState("");
  const [email, setEmail] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [reload, setReload] = useState("");
  // State variables for error flags
  const [fullNameError, setfullNameError] = useState(false);
  const [nationalCodeError, setNationalCodeError] = useState(false);
  const [mobileError, setmobileError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [cardNumberError, setCardNumberError] = useState(false);
  const dateCal = useRef(null);
  let [date, setDate] = useState(new DateObject());
  const personalCardRef = useRef(null);
  const navigateTo = useNavigate();
  useEffect(() => {
    axios.post(`${prefixUrl()}/user/getAccount.php`).then((response) => {
      if (response.data.status) {
        setfullName(response.data.data.fullName);
        setNationalCode(response.data.data.nationalCode);
        setmobile(response.data.data.mobile);
        setEmail(response.data.data.email);
        setCardNumber(response.data.data.cardNumber);
        setDate(response.data.data.birthDate);
      }
    });
  }, []);

  const validateForm = () => {
    // Reset all error flags
    setfullNameError(false);
    setNationalCodeError(false);
    setmobileError(false);
    setEmailError(false);
    setCardNumberError(false);

    let isValid = true;

    if (fullName.trim() === "") {
      setfullNameError(true);
      toast.error("لطفا نام و نام خانوادگی را وارد کنید");
      isValid = false;
    }

    const nationalCodePattern = /^\d{10}$/;
    if (nationalCode !== "" && !nationalCodePattern.test(nationalCode.trim())) {
      setNationalCodeError(true);
      toast.error("کدملی را به درستی وار کنید");
      isValid = false;
    }

    const CardNumberPattern = /^\d{16}$/;
    if (cardNumber !== "" && !CardNumberPattern.test(cardNumber.trim())) {
      setCardNumberError(true);
      toast.error("شماره کارت را به درستی وار کنید");
      isValid = false;
    }

    // const mobilePattern = /^09\d{9}$/;
    // if (mobile !== "" && !mobilePattern.test(mobile.trim())) {
    //   setmobileError(true);
    //   toast.error("شماره موبایل را به درستی وارد کنید");
    //   isValid = false;
    // }

    const emailPattern = /^[A-Za-z\d._%+-]+@[A-Za-z\d.-]+\.[A-Za-z]{2,}$/;
    if (email !== "" && !emailPattern.test(email.trim())) {
      setEmailError(true);
      toast.error("ایمیل را  به درستی وارد کنید");
      isValid = false;
    }

    return isValid;
  };

  // Separate states for each section
  const [isPersonalFocused, setPersonalFocused] = useState(false);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        personalCardRef.current &&
        !personalCardRef.current.contains(event.target)
      ) {
        setPersonalFocused(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const handlePersonalCardClick = () => {
    setPersonalFocused(true);
  };

  const sendDataToBackend = () => {
    if (validateForm()) {
      const formData = new FormData();
      // formData.append("id", localStorage.getItem("userId"));

      formData.append("fullName", fullName);
      formData.append("nationalCode", nationalCode);
      // formData.append("mobile", mobile);
      formData.append("email", email);
      date
        ? formData.append("birthDate", date)
        : formData.append("birthDate", "");
      formData.append("cardNumber", cardNumber);
      axios
        .post(`${prefixUrl()}/user/addAccount.php`, formData)
        .then((response) => {
          if (response.data.status) {
            // Registration is successful, reset all fields
            // setfullName("");
            // setNationalCode("");
            // // setmobile("");
            // setEmail("");
            // setDate(new DateObject());
            // setReload(Math.random());
            localStorage.setItem("name", fullName)
            toast.success(response.data.message);
          } else {
            // Handle unsuccessful registration if needed
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          // Handle any errors that occurred during the request
          console.error("Error occurred while sending data:", error);
        });
    }
  };

  const handleRegisterButtonClick = () => {
    const isValid = true;
    // const isValid = validateForm();
    if (isValid) {
      sendDataToBackend();
    } else {
      console.log("Registration has errors!");
    }
  };

  const handleInputChange = (setError, setValue) => (e) => {
    setError(false);
    setValue(e.target.value);
  };

  const cancleBtn = () => {
    navigateTo("/user");
  };

  return (
    <div className="UserInformation">
      <>
        <div className="PersonalInformation">
          <div className="Titel">
            <span>اطلاعات کاربری</span>
          </div>
          <div
            className={`CardPersonalInformation ${
              isPersonalFocused ? "focused-card" : ""
            }`}
            ref={personalCardRef}
            onClick={handlePersonalCardClick}
          >
            <form>
              <div className="rowPersonalInformation">
                <DynaInput
                  typeMode={"input"}
                  className={`solid-login-Personal-Information ${
                    fullNameError ? "solid-login-type-error" : ""
                  }`}
                  label="نام و نام خانوادگی"
                  type="text"
                  placeholder="اطلاعات خود را وارد کنید"
                  value={fullName}
                  onChange={handleInputChange(setfullNameError, setfullName)}
                />
                <div className="date">
                  <label>تاریخ تولد</label>
                  <DatePicker
                    ref={dateCal}
                    calendar={persian}
                    className={"Date"}
                    placeholder="اطلاعات خود را وارد کنید"
                    locale={persian_fa}
                    value={date}
                    onChange={(value) => setDate(value)} // Update the date state when the user selects a new date
                    calendarPosition="bottom-right"
                    hideOnScroll
                  />
                </div>
              </div>
              <div className="rowPersonalInformation">
                {/* <DynaInput
                  typeMode={"input"}
                  className={`solid-login-Personal-Information ${
                    mobileError ? "solid-login-type-error" : ""
                  }`}
                  label="شماره موبایل"
                  type={"number"}
                  placeholder="اطلاعات خود را وارد کنید"
                  value={mobile}
                  onChange={handleInputChange(setmobileError, setmobile)}
                /> */}

                <DynaInput
                  typeMode={"input"}
                  className={`solid-login-Personal-Information ${
                    emailError ? "solid-login-type-error" : ""
                  }`}
                  label="ایمیل"
                  type="text"
                  placeholder="اطلاعات خود را وارد کنید"
                  value={email}
                  onChange={handleInputChange(setEmailError, setEmail)}
                />
                <DynaInput
                  typeMode={"input"}
                  className={`solid-login-Personal-Information ${
                    cardNumberError ? "solid-login-type-error" : ""
                  }`}
                  name="cardNumberError"
                  label="شماره کارت"
                  type={"number"}
                  placeholder="اطلاعات خود را وارد کنید"
                  value={cardNumber}
                  onChange={handleInputChange(
                    setCardNumberError,
                    setCardNumber
                  )}
                />
              </div>
              {/* <div className="rowPersonalInformation">
               
              </div> */}
            </form>
          </div>
        </div>

        <div className="buttonUserInformation">
          <div className="btnCancel">
            <button onClick={() => cancleBtn()}>انصراف</button>
          </div>
          <div className="btnSubmit">
            <button onClick={handleRegisterButtonClick}>ثبت</button>
          </div>
        </div>
      </>
    </div>
  );
};

export default UserInformation;
